import { useEffect, useContext, FC, useState } from 'react'
import { useRouter } from 'next/router'
import { useBreakpointValue, useDisclosure } from '@chakra-ui/react'
import SidebarContext, { SidebarType } from './Context'

type Props = {
  children: JSX.Element
}

const SidebarProvider: FC<Props> = ({ children }) => {
  const isMobile = useBreakpointValue({ base: true, sm: true, md: false })
  const { isOpen, onClose, onOpen } = useDisclosure()
  const { asPath } = useRouter()
  const [activePath, setActivePath] = useState()

  useEffect(() => {
    if (isMobile) return onClose()
    onOpen()
  }, [isMobile])

  useEffect(() => {
    if (isMobile) {
      if (activePath !== asPath) {
        onClose()
      }
      setActivePath(activePath)
    }
  }, [asPath])

  return <SidebarContext.Provider value={{ isOpen, onClose, onOpen }}>{children}</SidebarContext.Provider>
}

export default SidebarProvider

export const useSidebar = () => useContext<SidebarType>(SidebarContext)
